import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import store from '@/store/index'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: 'login' */ '@/views/login/index.vue')
  },
  {
    path: '/',
    name: 'home',
    component: Layout,
    children: [
      {
        path: '', // 默认子路由
        name: 'index',
        component: () => import(/* webpackChunkName: 'index' */ '@/views/home/index.vue'),
        meta: {
          title: '首页'
        },
      },
      {
        path: '/certificate', // 默认子路由
        name: 'certificate',
        component: () => import(/* webpackChunkName: 'certificate' */ '@/views/certificate/index.vue'),
        meta: {
          title: '证据管理'
        },
      },
      {
        path: '/fieldConfig', // 默认子路由
        name: 'fieldConfig',
        component: () => import(/* webpackChunkName: 'fieldConfig' */ '@/views/fieldconfig/index.vue'),
        meta: {
          title: '自定义配置'
        }
      }
    ]
  },
  {
    path: '/certificateDetail', // 默认子路由
    name: 'certificateDetail',
    component: () => import(/* webpackChunkName: 'certificateDetail' */ '@/views/certificate/detail.vue'),
    meta: {
      title: '证据管理'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
